import React from "react";
import PropTypes from "prop-types";
import Select from "react-select-plus";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { ButtonCommonTheme } from "modules/theme";
import { ControlLabel, FormControl } from "modules/theme";
import { router, searchCompany } from "modules/common/utils";
import { Alert } from "modules/theme";
import Toggle from "react-toggle";
import { FormWrapper, FormColumn, ModalFooter } from "modules/theme";
import { ModalTrigger, FormGroup } from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";
import APIManager from "modules/common/apiManager";
import { FlexItem, InsightFilter, ItemSearch } from "../styles/main";
import { KIND_CHOICES as INTEGRATIONS_TYPES, timezones } from "./timezones";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import styled from "styled-components";
import CommonManager from "../../../../../helpers/common";
import { Component } from "react";

const commonManager = new CommonManager();
var uuid = require("uuid");
let { REACT_APP_API_URL } = process.env;
let tAPI = localStorage.getItem("REACT_APP_API_URL");
if (
  tAPI &&
  typeof tAPI !== "undefined" &&
  tAPI !== "undefined" &&
  tAPI !== ""
) {
  REACT_APP_API_URL = tAPI;
}

const propTypes = {
  brands: PropTypes.array.isRequired,
  queryParams: PropTypes.object,
  history: PropTypes.object,
};

const contextTypes = {
  __: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
};

class Filter extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    let zone = commonManager.getTimeZone();

    const { startDate, endDate } = commonManager.calculateTimeRange(
      this.props.initialDatesBy || "Last 24 Hrs",
      zone
    );

    try {
      this.currentTimestamp =
        parseInt(
          moment()
            .endOf("day")
            .tz(zone.value)
            .format("X")
        ) * 1000;
      this.dayBeforeTimeStamp =
        parseInt(
          moment()
            .subtract(30, "days")
            .tz(zone.value)
            .format("X")
        ) * 1000;
    } catch (err) {}
    this.state = {
      startDate,
      endDate,
      isChange: false,
      CampaignList: [],
      projects: [],
      selectedCampaign: [],
      selectedFilter: null,
      formatDate: "",
      freeTextSearch: null,
      filterName: null,
      filterNameUpdate: null,
      _id: "",
      fromSelector: null,
      toSelector: null,
      GroupBy: null,
      isNew: true,
      toshowGroupby: 0,
      DatesBy: props.initialDatesBy || null,
      showStartEndDate: false,
      selectedColumns: [],
      timezone: zone,
      showHide: false,
      modalType: modalType,
      TeamList: [],
      selectedTeam: [],
      UserList: [],
      selectedUser: [],
      ...props.queryParams,
    };
    this.handleProjectSearch = this.handleProjectSearch.bind(this);
    this.checkField = this.checkField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.resetAllData = this.resetAllData.bind(this);
    this.handleTeamSearch = this.handleTeamSearch.bind(this);
    this.handleUserSearch = this.handleUserSearch.bind(this);
  }

  componentDidMount() {
    this.handleProjectSearch();
    this.handleTeamSearch();
    this.handleUserSearch();

    if (
      Array.isArray(this.props.filterList) &&
      this.props.filterList.includes("renderTeam")
    ) {
      this.getTeam();
    }
    if (
      Array.isArray(this.props.filterList) &&
      this.props.filterList.includes("renderCampaign")
    ) {
      this.getCampaign();
    }

    if (this.props.filterList.includes("renderUser")) {
      this.getUser();
    }

    if (window.localStorage) {
    } else {
      this.setState({ toshowGroupby: 0 });
    }
  }

  componentWillReceiveProps(nextProps) {
    let result = nextProps.getSelectedColumnNames();
    this.setState({
      selectedColumns: result,
    });
    let tzone = commonManager.getTimeZone();
    let zone = {
      label: tzone,
      value: tzone,
    };
    if (
      nextProps.selectedFilter &&
      typeof nextProps.selectedFilter.filterName !== "undefined" &&
      (typeof this.props.selectedFilter === "undefined" ||
        nextProps.selectedFilter.filterName !==
          this.props.selectedFilter.filterName)
    ) {
      if (
        nextProps.selectedFilter.filterJson &&
        nextProps.selectedFilter.filterJson.GroupBy &&
        typeof nextProps.selectedFilter.filterJson.GroupBy !== "undefined"
      ) {
        if (nextProps.selectedFilter.filterJson.DatesBy !== "Custom Date") {
          this.setState({
            showStartEndDate: false,
          });
        } else {
          this.setState({
            showStartEndDate: true,
          });
        }
        if (
          nextProps.selectedFilter.filterJson.startDate === "" ||
          nextProps.selectedFilter.filterJson.endDate === "" ||
          nextProps.selectedFilter.filterJson.timezone === "" ||
          nextProps.selectedFilter.filterJson.timezone === null
        ) {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: this.dayBeforeTimeStamp,
            endDate: this.currentTimestamp,
            GroupBy: nextProps.selectedFilter.filterJson.GroupBy,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
          });
        } else {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: nextProps.selectedFilter.filterJson.startDate,
            endDate: nextProps.selectedFilter.filterJson.endDate,
            GroupBy: nextProps.selectedFilter.filterJson.GroupBy,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
          });
        }
      } else {
        if (nextProps.selectedFilter.filterJson.DatesBy !== "Custom Date") {
          this.setState({
            showStartEndDate: false,
          });
        } else {
          this.setState({
            showStartEndDate: true,
          });
        }
        if (
          nextProps.selectedFilter.filterJson.startDate === "" ||
          nextProps.selectedFilter.filterJson.endDate === "" ||
          nextProps.selectedFilter.filterJson.timezone === "" ||
          nextProps.selectedFilter.filterJson.timezone === null
        ) {
          let zone = commonManager.getTimeZone();
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: this.dayBeforeTimeStamp,
            endDate: this.currentTimestamp,
            freeTextSearch: nextProps.selectedFilter.filterJson.freeTextSearch,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
          });
        } else {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: nextProps.selectedFilter.filterJson.startDate,
            endDate: nextProps.selectedFilter.filterJson.endDate,
            freeTextSearch: nextProps.selectedFilter.filterJson.freeTextSearch,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
          });
        }
      }
    }
  }

  handleProjectSearch(value) {
    searchCompany(value, (CampaignList) => this.setState({ CampaignList }));
  }

  handleTeamSearch(value) {
    searchCompany(value, (TeamList) => this.setState({ TeamList }));
  }
  handleUserSearch(value) {
    searchCompany(value, (UserList) => this.setState({ UserList }));
  }

  onFilterByDate(type, date) {
    if (this.state.isChange) {
      const formatDate = date ? moment(date).format("YYYY-MM-DD HH:mm") : null;
    }
  }

  getCampaign() {
    var that = this;
    this.mAPI.sendGetAPI(
      `campaign?limit=100&page_no=1`,
      (data) => {
        if (data && data.data) {
          that.setState({ CampaignList: data.data });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  getTeam() {
    var that = this;
    this.mAPI.sendGetAPI(
      `team/list?limit=100&page_no=1`,
      (data) => {
        if (data && data.data) {
          that.setState({ TeamList: data.data });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  getUser() {
    var that = this;
    this.mAPI.sendGetAPI(
      `user?limit=100&page_no=1`,
      (data) => {
        if (data && data.data) {
          that.setState({ UserList: data.data });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onSubmit = () => {
    let tData = Object.assign({}, this.state);
    if (this.state.timezone) {
      window.localStorage.setItem(
        "timezone",
        JSON.stringify(this.state.timezone)
      );
    }

    this.props.getData(tData);
  };

  generateProjectParams(tData) {
    return tData.map((data) => ({
      value: data._id,
      label: data.name || "",
    }));
  }

  renderTimezones() {
    const { __ } = this.context;
    var that = this;
    return (
      <FixSelectStyle>
        <FlexItem>
          <ControlLabel>Timezone</ControlLabel>
          <Select
            placeholder={__("Timezone")}
            clearable={false}
            onChange={(selectedOption) => {
              if (selectedOption && selectedOption !== null) {
                that.setState({
                  timezone: selectedOption,
                });
              }
            }}
            value={this.state.timezone}
            options={timezones}
          />
        </FlexItem>
      </FixSelectStyle>
    );
  }

  renderCampaign() {
    const { __ } = this.context;
    return (
      <FixSelectStyle>
        <FlexItem>
          <ControlLabel>Campaign</ControlLabel>
          <Select
            placeholder={__("Campaign")}
            onFocus={() => this.handleProjectSearch("")}
            onInputChange={this.handleProjectSearch}
            onChange={(selectedOption) => {
              this.setState({
                selectedCampaign: selectedOption,
              });
            }}
            value={this.state.selectedCampaign}
            options={this.generateProjectParams(this.state.CampaignList)}
            multi
          />
        </FlexItem>
      </FixSelectStyle>
    );
  }

  renderFormGroup(label, props) {
    return (
      <FlexItem>
        <ItemSearch>
          <ControlLabel>{label}</ControlLabel>
          <FormControl
            type="text"
            // placeholder={__('Type to search')}
            // onChange={e =>
            //   this.setState({ freeTextSearch: e.target.value })
            // }
            // value={this.state.freeTextSearch}
            {...props}
          />
        </ItemSearch>
      </FlexItem>
    );
  }

  handleChange(event) {
    this.setState({ filterName: event.currentTarget.value });
  }

  generateEntitysParams(supportedEntityList) {
    return supportedEntityList.map((entity) => ({
      value: entity,
      label: entity,
    }));
  }
  renderFrom() {
    return (
      <FlexItem>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup("From", {
              defaultValue: "",
              placeholder: "From",
              required: true,
              id: "from",
              value: this.state.fromSelector,
              onChange: (e) => {
                this.setState({ fromSelector: e.target.value });
              },
            })}
          </FormColumn>
        </FormWrapper>
      </FlexItem>
    );
  }
  renderTo() {
    return (
      <FlexItem>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup("To", {
              defaultValue: "",
              placeholder: "To",
              required: true,
              id: "to",
              value: this.state.toSelector,
              onChange: (e) => {
                this.setState({ toSelector: e.target.value });
              },
            })}
          </FormColumn>
        </FormWrapper>
      </FlexItem>
    );
  }

  renderTeam() {
    const { __ } = this.context;
    return (
      <FixSelectStyle>
        <FlexItem>
          <ControlLabel>Team</ControlLabel>
          <Select
            placeholder={__("Team")}
            onFocus={() => this.handleTeamSearch("")}
            onInputChange={this.handleTeamSearch}
            onChange={(selectedOption) => {
              this.setState({
                selectedTeam: selectedOption,
              });
            }}
            value={this.state.selectedTeam}
            options={this.generateProjectParams(this.state.TeamList)}
            multi
          />
        </FlexItem>
      </FixSelectStyle>
    );
  }

  renderUser() {
    const { __ } = this.context;
    return (
      <FixSelectStyle>
        <FlexItem>
          <ControlLabel>User</ControlLabel>
          <Select
            placeholder={__("User")}
            onFocus={() => this.handleUserSearch("")}
            onInputChange={this.handleUserSearch}
            onChange={(selectedOption) => {
              this.setState({
                selectedUser: selectedOption,
              });
            }}
            value={this.state.selectedUser}
            options={this.generateProjectParams(this.state.UserList)}
            multi
          />
        </FlexItem>
      </FixSelectStyle>
    );
  }

  resetAllData() {
    let zone = commonManager.getTimeZone();
    const { startDate, endDate } = commonManager.calculateTimeRange(
      this.props.initialDatesBy || "Today",
      zone
    );
    let tData = {
      startDate,
      endDate,
      freeTextSearch: "",
      fromSelector: "",
      toSelector: "",
      DatesBy: this.props.initialDatesBy || null,
      selectedUser: "",
      selectedTeam: "",
      selectedCampaign: "",
    };
    // this.setState({
    //   startDate: '',
    //   endDate: '',
    //   freeTextSearch: '',
    //   fromSelector: '',
    //   toSelector: ''
    // });
    if (typeof this.props.DefaultSelectedField === "object") {
      tData = { ...tData, ...this.props.DefaultSelectedField };
    }
    this.setState(tData);
    this.props.getData(tData);
  }

  checkField(field) {
    const { filterList = [] } = this.props;
    return filterList && filterList.includes(field);
  }
  render() {
    const { __ } = this.context;
    const { hideDate } = this.props;
    const props = {
      inputProps: { placeholder: __("Click to select a date") },
      timeFormat: "HH:mm",
      dateFormat: "YYYY/MM/DD",
    };
    let zone = commonManager.getTimeZone();

    return (
      <InsightFilter className="p-0 overflow-x-hidden d-flex flex-column">
        {/* <InsightTitle>{this.props.showButton()}</InsightTitle> */}
        <div
          className="w-100 m-0 py-2 position-relative overflow-x-auto"
          style={{ height: "calc(100% - 86px)" }}
        >
          {this.checkField("renderFrom") && (
            <Col className="my-2 px-5" md={12}>
              {this.renderFrom()}
            </Col>
          )}
          {this.checkField("renderTo") && (
            <Col className="my-2 px-5" md={12}>
              {this.renderTo()}
            </Col>
          )}
          {this.checkField("renderTimezones") && (
            <Col className="my-2 px-5" md={12}>
              {this.renderTimezones()}
            </Col>
          )}
          {this.checkField("renderTeam") && (
            <Col className="my-2 px-5" md={12}>
              {this.renderTeam()}
            </Col>
          )}
          {this.checkField("renderCampaign") && (
            <Col className="my-2 px-5" md={12}>
              {this.renderCampaign()}
            </Col>
          )}
          {this.checkField("renderUser") && (
            <Col className="my-2 px-5" md={12}>
              {this.renderUser()}
            </Col>
          )}
          {!hideDate &&
            (this.state.toshowGroupby !== 4 ||
              (this.state.GroupBy === "Call Date" &&
                this.state.toshowGroupby === 4)) && (
              <Col className="my-2 px-5" md={12}>
                <FixSelectStyle>
                  <FlexItem>
                    <ControlLabel>Select By Date</ControlLabel>
                    <Select
                      key={`${uuid.v4()}entity`}
                      value={this.state.DatesBy}
                      defaultValue={"Date"}
                      placeholder={__("Select Dates")}
                      clearable={this.props.clearable === false ? false : true}
                      options={this.generateEntitysParams([
                        "Today",
                        "Last 24 Hrs",
                        "Yesterday",
                        "Last 7 Days",
                        "Custom Date",
                      ])}
                      onChange={(items) => {
                        let selected = null;

                        if (
                          items &&
                          typeof items !== "undefined" &&
                          window.localStorage
                        ) {
                          selected = items.value;
                          let zone = commonManager.getTimeZone();

                          if (!selected) {
                            this.setState({
                              showStartEndDate: false,
                              startDate: "",
                              endDate: "",
                              sendStartTime: "",
                              sendEndTime: "",
                              DatesBy:
                                (this.props.DefaultSelectedField &&
                                  this.props.DefaultSelectedField.DatesBy &&
                                  this.props.DefaultSelectedField.DatesBy) ||
                                null,
                            });
                            return;
                          }
                          const {
                            startDate,
                            endDate,
                          } = commonManager.calculateTimeRange(selected, zone);

                          this.setState({
                            startDate,
                            endDate,
                            DatesBy: selected,
                            showStartEndDate:
                              selected === "Custom Date" ? true : false,
                          });
                        } else {
                          this.setState({
                            showStartEndDate: false,
                          });
                        }
                        this.setState({
                          DatesBy: selected,
                          // showStartEndDate: false
                        });
                      }}
                    />
                  </FlexItem>
                </FixSelectStyle>
              </Col>
            )}
          {(this.state.toshowGroupby == 2 ||
            (this.state.GroupBy !== "Call Date" &&
              this.state.toshowGroupby == 4)) && (
            <Col className="my-2 px-5" md={12}>
              <FlexItem>
                <ControlLabel>Select date</ControlLabel>
                <Datetime
                  // {...props}
                  value={this.state.startDate}
                  inputProps={{ placeholder: "Select Date" }}
                  onBlur={this.onFilterByDate.bind(this, "startDate")}
                  onChange={(date) => {
                    this.setState({
                      startDate:
                        parseInt(
                          moment(date)
                            .tz(zone.value)
                            .format("X")
                        ) * 1000,
                    });
                  }}
                />
              </FlexItem>
            </Col>
          )}
          {this.state.showStartEndDate && this.state.toshowGroupby !== 2 && (
            <Col
              md={12}
              style={{ background: "#F2F2F2", padding: "11px" }}
              className="px-4"
            >
              <Col className="my-2" md={6}>
                <FlexItem style={{ display: "block" }}>
                  <ControlLabel>Start date</ControlLabel>
                  <Datetime
                    className="datatime-wrapper"
                    inputProps={{ placeholder: "Select Date", readOnly: true }}
                    value={this.state.startDate}
                    onBlur={this.onFilterByDate.bind(this, "startDate")}
                    onChange={(date) => {
                      if (
                        parseInt(
                          moment(date)
                            .tz(zone.value)
                            .format("X")
                        ) *
                          1000 >
                        this.state.endDate
                      ) {
                        this.setState({
                          endDate:
                            parseInt(
                              moment(date)
                                .tz(zone.value)
                                .format("X")
                            ) * 1000,
                        });
                      }
                      this.setState({
                        startDate:
                          parseInt(
                            moment(date)
                              .tz(zone.value)
                              .format("X")
                          ) * 1000,
                      });
                    }}
                  />
                  <span class="icon material-symbols-outlined">
                    calendar_month
                  </span>
                </FlexItem>
              </Col>
              <Col className="my-2" md={6}>
                <FlexItem style={{ display: "block" }}>
                  <ControlLabel>End date</ControlLabel>
                  <Datetime
                    left={true}
                    className="datatime-wrapper datetime-wrapper-move-left"
                    // {...props}
                    inputProps={{ placeholder: "Select Date", readOnly: true }}
                    value={this.state.endDate}
                    onBlur={this.onFilterByDate.bind(this, "endDate")}
                    isValidDate={(date) =>
                      parseInt(
                        moment(date)
                          .tz(zone.value)
                          .format("X")
                      ) *
                        1000 >=
                      this.state.startDate
                    }
                    onChange={(date) => {
                      this.setState({
                        endDate:
                          parseInt(
                            moment(date)
                              .tz(zone.value)
                              .format("X")
                          ) * 1000,
                      });
                    }}
                  />
                  <span class="icon material-symbols-outlined">
                    calendar_month
                  </span>
                </FlexItem>
              </Col>
            </Col>
          )}
          {this.checkField("renderFreeText") &&
            (this.state.toshowGroupby === 0 ||
              this.state.toshowGroupby === 1 ||
              this.state.toshowGroupby === 4) && (
              <Col className="my-2 px-5" md={12}>
                <FlexItem>
                  <FormWrapper>
                    <FormColumn>
                      {this.renderFormGroup("Free Text Search", {
                        defaultValue: "",
                        placeholder: "",
                        required: true,
                        id: "freeTextSearch",
                        value: this.state.freeTextSearch,
                        onChange: (e) => {
                          this.setState({ freeTextSearch: e.target.value });
                        },
                      })}
                    </FormColumn>
                  </FormWrapper>
                </FlexItem>
              </Col>
            )}
          {/* // <FlexItem>
                //   <ItemSearch>
                //     <ControlLabel>Free Text Search</ControlLabel>
                //     <FormControl
                //       type="text"
                //       placeholder={__('Type to search')}
                //       onChange={e =>
                //         this.setState({ freeTextSearch: e.target.value })
                //       }
                //       value={this.state.freeTextSearch}
                //     />
                //   </ItemSearch>
                // </FlexItem> */}
          {(this.state.toshowGroupby === 1 ||
            this.state.toshowGroupby === 4) && (
            <Col className="my-2 px-5" md={12}>
              <FlexItem>
                <ControlLabel>Group By</ControlLabel>
                <Select
                  key={`${uuid.v4()}entity`}
                  value={this.state.GroupBy}
                  defaultValue={"Call Date"}
                  placeholder={__("Select to GroupBy")}
                  options={this.generateEntitysParams([
                    "Call Date",
                    "InterMedia",
                    "Promo Code",
                    "Radial Error",
                    "DNIS",
                    "Creative Code",
                  ])}
                  onChange={(items) => {
                    let selected = null;
                    if (items && items.value) {
                      selected = items.value;
                    }
                    if (selected !== "Call Date") {
                      let mStartDate =
                        parseInt(
                          moment()
                            .startOf("day")
                            .tz(zone.value)
                            .format("X")
                        ) * 1000;
                      let date =
                        parseInt(
                          moment()
                            .endOf("day")
                            .tz(zone.value)
                            .format("X")
                        ) * 1000;
                      let mStartTimeStamp = mStartDate;
                      let mEndTimeStamp = date;
                      this.setState({
                        startDate: mStartTimeStamp,
                        endDate: mEndTimeStamp,
                        showStartEndDate: false,
                        GroupBy: selected,
                      });
                    } else {
                      this.setState({
                        GroupBy: selected,
                      });
                    }
                  }}
                />
              </FlexItem>
            </Col>
          )}
        </div>
        {/*   <FlexRow></FlexRow> */}
        {/* <div
          className='conainer-fluid w-100 p-5 bg-white position-absolute bottom-0'
          style={{ 'box-shadow': '0px -5px 20px rgba(0, 0, 0, 0.1)' }}
        >
          <FlexRow> */}
        <FlexItem
          className="conainer-fluid w-100 bg-white bottom-0"
          style={{
            "box-shadow": "0px -5px 20px rgba(0, 0, 0, 0.1)",
            padding: "20px",
          }}
        >
          <ButtonCommonTheme
            className="FilterModalBtn"
            type="greyModalBtn"
            style={{ marginLeft: "10px" }}
            modalBtnTitle="Reset"
            OnClick={this.resetAllData}
          />
          <ButtonCommonTheme
            className="FilterModalBtn"
            type="blueModalBtn"
            modalBtnTitle="Apply"
            OnClick={this.onSubmit}
          />
        </FlexItem>
        {/* </FlexRow>
        </div> */}
      </InsightFilter>
    );
  }
}

Filter.propTypes = propTypes;
Filter.contextTypes = contextTypes;

export default Filter;

const FixSelectStyle = styled.div`
  .Select-placeholder {
    display: flex;
    align-items: center;
  }
  .Select-placeholder,
  .Select-input,
  .Select--single > .Select-control .Select-value {
    padding-left: 15px !important;
  }
  .Select.is-focused .Select-input > input {
    padding: 12px 0 12px !important;
  }
`;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/Filter.js